import { Component, OnInit, Input} from '@angular/core';
import { AuthServiceApi } from 'src/app/services/services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { matchOtherValidator } from 'src/app/util/auth/match-other.directive';
import {Subject} from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { setForcePasswordChangeFlag } from 'src/app/util/auth/helpers';

interface IData {
  id: string;
  currentPassword: boolean;
}
@Component({
    selector: 'app-service-modal-change-password',
    templateUrl: './service-modal-change-password.component.html',
    styleUrls: ['./service-modal-change-password.component.scss'],
    standalone: false
})
export class ServiceModalChangePasswordComponent implements OnInit {

  public currentPassword: boolean;

  private _error = new Subject<string>();
  private _success = new Subject<string>();

  changePasswordForm: FormGroup;
  errorMessage: string = '';
  successMessage = '';
  change = false;
  showCurrentPassword = false;
  showPassword = false;
  showConfirmPassword = false;

  @Input() public data: IData = {
    id: null,
    currentPassword: true
  };

  /** Si true (p. ej. post-recover), el modal no se puede cerrar sin cambiar la clave. */
  @Input() public forceChange = false;

  constructor(public _authApi : AuthServiceApi,  private _fboulder: FormBuilder, private modalService: NgbModal) { }

  ngOnInit() {
   this.changePasswordForm = this._fboulder.group({
      currentpassword: ['', this.data.currentPassword ? [Validators.required] : ''],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmpassword: ['', [Validators.required, matchOtherValidator('password')]]
    });
		this._success.subscribe(message => this.successMessage = message);
    this._success.pipe (
			debounceTime(8000)
		).subscribe(() => this.successMessage = '');

		this._error.subscribe(message => this.errorMessage = message);
    this._error.pipe (
			debounceTime(8000)
    ).subscribe(() => this.errorMessage = '');

    this.currentPassword = this.data.currentPassword;
  }

  isValid() : boolean{
    if(this.changePasswordForm.invalid){
      return true;
    }
    return false;
  }

  onSubmit() {

    this.change = true;

    if (!this.isValid()) {

      const body = this.data.id ?
      {
        userid: this.data.id,
        newpassword: this.changePasswordForm.controls.password.value
      } :
      {
        oldpassword: this.changePasswordForm.controls.currentpassword.value,
        newpassword: this.changePasswordForm.controls.password.value
      };


    this._authApi.changePassword(body).subscribe({
      next: response => {
        this.change = false;
        if (response['result']) {
          setForcePasswordChangeFlag(false);
          this._success.next(
            this.data.id
              ? 'Se cambió la contraseña y se envió la notificación por correo.'
              : 'Se cambió la contraseña exitosamente!!'
          );
          setTimeout(() => this.closeModal(), 3000);
        } else {
          this._error.next('No se pudo cambiar la contraseña, Inténtelo de nuevo, por favor!!.');
        }
      },
      error: () => {
        this.change = false;
        this._error.next('No se pudo cambiar la contraseña. Revisa que cumpla el mínimo de 8 caracteres e inténtalo de nuevo.');
      }
    });
    }


  }

  closeModal() {
    // En cambio forzado no se permite cerrar hasta completar el submit exitoso.
    if (this.forceChange && !this.successMessage) {
      return;
    }
    this.modalService.dismissAll();
	}

}
